<template>
    <div class="align-center mb-3">
        <div v-if="FilterChips.length > 0" class="d-inline">Displaying:</div>
        <v-chip
            v-for="item in FilterChips"
            :key="item"
            class="mr-2 mb-2 font-weight-medium d-inline py-2"
            label
            color="accent"
            text-color="general_grey"
            close
            close-icon="mdi-close"
            @click:close="remove(item)">
            <!-- string that comes in >>> 'filterCategory:filterId:displayText  -->
            {{ item.split(':')[2] }}
        </v-chip>
    </div>
</template>

<script>

  export default {
    name: 'ListingsFilter',
    props: [
        'FilterChips',
        'TriggerFilters',
    ],
    data() {
      return {
      }
    },
    mounted () {
      // string that comes in > 'filterCategory:filterId:displayText
      // console.log('FilterChips: ',this.FilterChips)
    },
    methods: {
      remove (item) {
        // blue-grey lighten-4 || grey darken-1
        this.$emit('FilterChips', this.FilterChips.splice(this.FilterChips.indexOf(item), 1))
        // this.$emit('filteredListings', this.filteredListings.splice(this.filteredListings.indexOf(item), 1))
        this.$emit('TriggerFilters', !this.TriggerFilters)
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ListingFilters.vue